/**
 *
 * @module clearWatchlistQuery
 *
 */

import ContentQuery from './../contentQuery';
import GraphQlPersistedQuery from './../graphQlPersistedQuery';

/**
 *
 * @class ClearWatchlistQuery
 * @extends {SDK.Content.ContentQuery}
 *
 */
export default class ClearWatchlistQuery extends ContentQuery {

    constructor() {

        super('watchlistPersisted', new GraphQlPersistedQuery('clearWatchlist'));

    }

}



// WEBPACK FOOTER //
// ./src/content/watchlist/clearWatchlistQuery.js